module.exports = __webpack_public_path__ + "img/363812773_274569951854520_6753081290197446955_n.2bc8578a.jpeg";